var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7031 13.9766H16.7031M8.70312 13.9766H8.7121M13.7031 17.9766H8.70312M16.7031 17.9766H16.6941",
    stroke: "#8E93B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7031 2.97656V4.97656M6.70312 2.97656V4.97656",
    stroke: "#8E93B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20312 13.2198C3.20312 8.8625 3.20312 6.68384 4.45525 5.3302C5.70737 3.97656 7.72262 3.97656 11.7531 3.97656H13.6531C17.6836 3.97656 19.6989 3.97656 20.951 5.3302C22.2031 6.68384 22.2031 8.8625 22.2031 13.2198V13.7334C22.2031 18.0907 22.2031 20.2693 20.951 21.623C19.6989 22.9766 17.6836 22.9766 13.6531 22.9766H11.7531C7.72262 22.9766 5.70737 22.9766 4.45525 21.623C3.20312 20.2693 3.20312 18.0907 3.20312 13.7334V13.2198Z",
    stroke: "#8E93B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70312 8.97656H21.7031",
    stroke: "#8E93B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar2.ad9d20eb055b966951c34e8973531e11.svg";
export { ForwardRef as ReactComponent };